import React from 'react';
import LoadingModalPage from './LoadingModalPage';
import TransparentLogo from '../images/TransparentLogo.png';
const HomePage = () => {
  return (
    <>
      <div className="flex flex-col w-full items-center">
        <span className="text-6xl py-10 text-blue-second">
          Thank you for choosing our services
        </span>
        <img
          src={TransparentLogo}
          alt="Logo"
          className="hidden xl:flex h-52 bg-white rounded-full"
        />
      </div>
      {<LoadingModalPage loading={true} />}
    </>
  );
};

export default HomePage;
